import { Component } from '@angular/core';

@Component({
  selector: 'trpx-trust-dubai',
  templateUrl: './trust-dubai.component.html',
  styleUrls: ['./trust-dubai.component.scss']
})
export class TrustDubaiComponent {
slides: any[] = [];
  groupedSlides: any[][] = [];

  constructor() {
    this.slides = [
      {
        image: './assets/images/Instant_.webp',
        heading: 'Instant Vibes Only',
        description:
          'No patience? Neither do we. Instant confirmations and bookings in seconds, not days.',
      },
      // {
      //   image: './assets/images/Authentic-Experiences.webp',
      //   heading: 'Trusted by Millions',
      //   description:
      //     '20+ years of expertise, delivering authentic, curated experiences.',
      // },
      
      {
        image: './assets/images/Curated_.webp',
        heading: 'Curated For Your Feed',
        description: 'Experiences hand-picked for max likes and epic stories. Every spot is a vibe.',
      },
      {
        image: './assets/images/Deals_.webp',
        heading: 'Deals that Slap',
        description: 'Your wallet’s gonna love us. Exclusive Gen Z-friendly deals so you can save for more adventures.',
      },
      {
        image: './assets/images/Flexibility_.webp',
        heading: 'Flexibility on Point',
        description: 'Plans changed? No stress. Easy changes and hassle-free cancellations so you can stay spontaneous.',
      },
      
      {
        image: './assets/images/Free_.webp',
        heading: 'Free Stuff FTW',
        description: 'Regular freebies and zero-cost adventures because living your best life shouldn’t break the bank.',
      },
    
      {
        image: './assets/images/We_.webp',
        heading: 'We Speak Your Language',
        description: 'Zero boring talk. Just chill support from real humans who totally get you.',
      },
      {
        image: './assets/images/Hidden_.webp',
        heading: 'Hidden Gems Unlocked',
        description: 'No tourist traps, just the secret spots locals love and influencers haven’t blown up yet.',
      },

      {
        image: './assets/images/Good_.webp',
        heading: 'Good Travel, Good Karma',
        description: 'Sustainable experiences because we know you care about the planet as much as your passport stamps.',
      },
    ];
    this.groupSlides();
  }

  ngOnInit(): void {}

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          dots: false,
          variableWidth: false,
        },
      },
    ],
  };

  private groupSlides() {
    this.groupedSlides = [];
    for (let i = 0; i < this.slides.length; i += 2) {
      this.groupedSlides.push(this.slides.slice(i, i + 2));
    }
  }

}
